// Main entry — the production View. (No Container: NumberField is a pure
// View.) Sim wrappers live under ./sim and are never imported here, so a
// production import of NumberField can't pull in fixtures.
export { NumberField } from "./NumberField";
export type { NumberFieldProps } from "./NumberField";
